import { Module } from 'vuex';
import { MailSettingState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: MailSettingState = {
    mailSetting: undefined,
    authentications: undefined,
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    update: {
        category: undefined,
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    connection: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const mailSetting: Module<MailSettingState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
